import { api } from "./api";

const key = (uid) => `fmis_offline_${uid}`;

export function listLocal(uid) {
  try { return JSON.parse(localStorage.getItem(key(uid)) || "[]"); } catch (e) { return []; }
}

function save(uid, items) {
  localStorage.setItem(key(uid), JSON.stringify(items));
}

export function saveLocal(uid, payload) {
  const items = listLocal(uid).filter((x) => x.client_uuid !== payload.client_uuid);
  items.unshift({ client_uuid: payload.client_uuid, payload, saved_at: new Date().toISOString(), state: "local" });
  save(uid, items);
}

export function removeLocal(uid, client_uuid) {
  save(uid, listLocal(uid).filter((x) => x.client_uuid !== client_uuid));
}

// Upload local drafts as server drafts; client_uuid makes retries idempotent.
export async function syncLocal(uid) {
  const items = listLocal(uid);
  let synced = 0;
  for (const it of items) {
    if (it.state !== "local") continue;
    try {
      const { data } = await api.post("/collections", { ...it.payload, submit: false });
      it.state = "synced";
      it.server_id = data.id;
      synced += 1;
    } catch (e) {
      if (!e.response) break;
      it.error = e.response?.data?.detail?.message || String(e.response?.data?.detail || "Sync failed");
    }
  }
  save(uid, items.filter((x) => x.state === "local"));
  return synced;
}
